import { ON_LOGOUT } from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';
import { clearUserDataFromStore } from 'core_main/store';
import { handleError } from 'globals/errors';
import { removeTrackingTokenFromLocalStorage } from 'helpers/browser';
import { login } from '../login';

export const logout = (cb) => {
  try {
    clearUserDataFromStore();
    removeTrackingTokenFromLocalStorage();
    login({}, (identity, error) => {
      if (typeof cb === 'function') cb(identity, error);
      runListenersForEvent(ON_LOGOUT, identity, error);
    });
  } catch (error) {
    if (typeof cb === 'function') cb(null, error);
    if (error instanceof Error) {
      runListenersForEvent(ON_LOGOUT, null, error);
    }
    handleError(error, { message: 'Failed to logout' });
  }
};
